import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  callbackContainerWrapper: {
    borderRadius: 8,
    backgroundColor: "#FCF3DE",
    padding: "12px",
    display: "flex",
    alignItems: "flex-start",
    marginTop: "40px",
  },
  mobileCallbackContainer: {
    borderRadius: 40,
    backgroundColor: "#000000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    width: 155,
    height: 39,
  },
  optionsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch",

    "& > *": {
      width: "100%",

      "@media (max-width: 779px)": {
        "&:not(:first-child)": {
          marginTop: "20px",
        },
      },
    },

    "@media (min-width: 780px)": {
      flexDirection: "row",

      "& > *": {
        width: "calc(50% - 10px)",

        "&:not(:first-child)": {
          marginLeft: "20px",
        },
      },
    },
  },

  textFieldRoot: {
    width: "100%",
    "& > .MuiInputBase-root > input": {
      height: "40px",
      padding: "10px 12px",
      borderRadius: "8px",
      fontFamily:"Plus Jakarta Sans",

      "&::placeholder": {
        textOverflow: "ellipsis !important",
        color: "#757575",
      },
    },

    "& .MuiInputAdornment-positionStart": {
      marginRight: 0,
    },
  },
  helperText: {
    marginBottom: "8px",
    fontSize: "20px",
    fontWeight: 600,
    textAlign: "left",
    wordWrap: "break-word",
    width: "70%",
  },
  changeNumber: {
    color: "#000000",
    fontWeight: 600,
    fontSize: 12,

    "&:hover": {
      cursor: "pointer",
    },
    marginRight: "5px",
  },
}));
